import { useNavigate } from "@tanstack/react-router"
import { useEffect } from "react"
import { JugglingScreen } from "@motley/design"
import { toast } from "sonner"
import { errorMessage } from "@/base"
import { useApplyResetPasswordMutation, useRedirectAfterLogin } from "@/auth"

const DEFAULT_ERROR = "Authentication failed. Please try again."

type Props = {
  token: string
}

export default function ApplyResetPassword({ token }: Props) {
  const [applyResetPassword] = useApplyResetPasswordMutation()
  const navigate = useNavigate()
  const { setRedirectUrl, clearRedirectUrl } = useRedirectAfterLogin()

  useEffect(() => {
    void (async () => {
      try {
        setRedirectUrl("/account")
        await applyResetPassword({ token }).unwrap()
        toast.success("You are logged in. Please set a new password.")
      } catch (e) {
        clearRedirectUrl()
        toast.error(errorMessage(e, DEFAULT_ERROR))
        await navigate({ to: "/auth/reset-password", replace: true })
      }
    })()
  }, [token, applyResetPassword, navigate, setRedirectUrl, clearRedirectUrl])

  return <JugglingScreen />
}
